import colorsOptions from '../../fundamentals/colors-styles/constants'
import styled, { css, keyframes } from 'styled-components'

const skeletonLoading = keyframes`
  0% {
    background-color: hsl(240, 11%, 85%);
  }
  100% {
    background-color: hsl(240, 11%, 95%);
  }
`

const SkeletonMaskContainer = styled.div`
  position: relative;
  width: 100px;
  height: 12px;
  border-radius: 15px;
  background-color: ${colorsOptions.greys['grey-20']};
  animation: ${skeletonLoading} 1s linear infinite alternate-reverse;

  ${({ skeletonShape }) => skeletonShape && css(skeletonShape)}
`

export { SkeletonMaskContainer }
